var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payuCard"},[_c('div',{staticClass:"container"},[_c('PayPal',{attrs:{"amount":_vm.cart.adCost,"currency":"MXN","client":_vm.credentials,"env":"sandbox","items":_vm.myItems,"invoice-number":_vm.cart.adKey}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }